import { ReactElement, useCallback } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { AddCircleIcon, Link } from '@dreryk/react-components';

import {
   DocplannerServiceMappingCreateModal,
   useDocplannerServiceMappingCreateModalState,
} from './docplannerServiceMappingCreate/DocplannerServiceMappingCreateModal';

type AddNewMappingModalOpenerProps = {
   readonly withLeadingIcon: boolean;
   readonly label: TranslatableText;
   readonly onMappingCreateSuccess: VoidFunction;
   readonly alreadySelectedServicesIds: number[] | undefined;
};

export const AddNewMappingModalOpener = (props: AddNewMappingModalOpenerProps): ReactElement => {
   const [
      openMappingCreateModal,
      closeMappingCreateModal,
      mappingModalOpened,
   ] = useDocplannerServiceMappingCreateModalState();

   const handleMappingCreateSuccess = useCallback(() => {
      closeMappingCreateModal();
      props.onMappingCreateSuccess();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeMappingCreateModal, props.onMappingCreateSuccess]);
   return (
      <>
         <Link
            testId={'addNewMapping'}
            onClick={openMappingCreateModal}
            label={props.label}
            icon={props.withLeadingIcon ? <AddCircleIcon /> : undefined}
         />
         {mappingModalOpened ? (
            <DocplannerServiceMappingCreateModal
               onMappingCreateSuccess={handleMappingCreateSuccess}
               onClose={closeMappingCreateModal}
               alreadySelectedServicesIds={props.alreadySelectedServicesIds}
            />
         ) : null}
      </>
   );
};
